module.exports = "/images/aerial-4.jpg";